const Integrations = () => {
  const IntegrationData = {
    accessTypeKey: "DFQweb8twCUzouLF4EjuRjmU",
    accessTypeBkIntegrationId: 4,
    stagingAccessTypeKey: "Fxugwc1mVDyJZ2dHB58bShso",
    stagingAccessTypeBkIntegrationId: 10,
    appKeys: {
      facebookAppkey: "292331211112295",
      googleClientId: "766089827850-3lfqip6dd01q3v06egtcgbf6c6sdvr5h.apps.googleusercontent.com",
      twitterAppkey: "6svdcdntc3WG74vvkAy3OK6Vh",
      stripeKey:
        "pk_live_51GxWtxFF68c8SrjMyKoVxBQeKbHUz8QBNfK1X1h40ZxEiUfYaRnIl2go56S7eM91L2paqmUsOOqapgC2Dpz3SIyr00HvQ8hLPS",
      razorpayKey: "rzp_live_1h1CuuFge3eW7I"
    },
    studentSubscriptionPlans: {
      oneTime: {
        "6": {
          amount: 1500,
          label: "6 months",
          stripe_key: "price_1Hgw09FF68c8SrjMtuLciypt"
        },
        "12": {
          amount: 3000,
          label: "1 year",
          stripe_key: "price_1Hgw09FF68c8SrjMuDmeoYvZ"
        }
      },
      recurring: {
        "6": {
          amount: 1500,
          label: "6 months",
          stripe_key: "price_1Hgw4zFF68c8SrjMM3fXfmug"
        },
        "12": {
          amount: 3000,
          label: "1 year",
          stripe_key: "price_1Hgw5LFF68c8SrjMj7uAXIYe"
        }
      }
    },
    podcatcherURLMap: {
      "5ec3d9497cef7479d2ef4798": {
        rss: "https://feeds.acast.com/public/shows/5ec3d9497cef7479d2ef4798",
        Podcast: "NL Hafta",
        SoundCloud: "https://soundcloud.com/newslaundrypodcast",
        Apple: "https://podcasts.apple.com/in/podcast/nl-hafta/id582585399",
        Spotify: "https://open.spotify.com/show/67hMBQ09Y5mKaQOavnkUkP?si=a84lFlh8RHuhzvv6wJKWpA",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast",
        TuneIn: "https://tunein.com/search/?query=NL%20Hafta",
        Hubhopper: "https://hubhopper.com/podcast/nl-hafta/309980",
        Castbox: "https://castbox.fm/channel/NL-Hafta-id2167779",
        Saavn: "https://www.jiosaavn.com/shows/nl-hafta/1/2GyfUNHrOug_",
        "Google Podcasts":
          "https://podcasts.google.com/?feed=aHR0cDovL2ZlZWRzLnNvdW5kY2xvdWQuY29tL3VzZXJzL3NvdW5kY2xvdWQ6dXNlcnM6MTEzMTI3MjYyL3NvdW5kcy5yc3M",
        Overcast: "https://overcast.fm/itunes582585399/nl-hafta",
        "Pocket Casts": "https://pca.st/95vI",
        "Podcast Addict": "https://podplayer.net/?podId=2848923",
        Headfone: "https://www.headfone.co.in/channel/nl-hafta/",
        Breaker: "https://www.breaker.audio/nl-hafta"
      },
      "5ec24dba84c3fb5c3f29dd3a": {
        rss: "https://feeds.acast.com/public/shows/5ec24dba84c3fb5c3f29dd3a",
        Podcast: "Awful and Awesome",
        SoundCloud: "https://soundcloud.com/user-178220350",
        Apple: "https://podcasts.apple.com/in/podcast/the-awful-awesome-entertainment-wrap/id1455348346",
        Spotify: "https://open.spotify.com/show/5mg9Z235VZ6zlvkFgSF1to?si=ofhXQaw5QgSO9vi_o5kHoA",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/the-awful-awesome-entertainment-wrap",
        TuneIn:
          "https://tunein.com/podcasts/Media--Entertainment-Podcasts/The-Awful--Awesome-Entertainment-Wrap-p1285252/",
        Hubhopper: "https://hubhopper.com/podcast/the-awful-awesome-entertainment-wrap/9628",
        Castbox: "https://castbox.fm/channel/The-Awful-%26-Awesome-Entertainment-Wrap-id2043817?country=us",
        Saavn: "https://www.jiosaavn.com/shows/the-awful--awesome-entertainment-wrap/1/gvlOq4j9uwo_",
        "Google Podcasts": "https://podcasts.google.com/?q=Awful%20and%20Awesome",
        Overcast: "https://overcast.fm/itunes1455348346/the-awful-awesome-entertainment-wrap",
        "Pocket Casts": "https://pca.st/At84",
        "Podcast Addict": "https://podplayer.net/?podId=2848925",
        Headfone: "https://www.headfone.co.in/channel/the-awful-awesome-entertainment-wrap/",
        Breaker: "https://www.breaker.audio/the-awful-and-awesome-entertainment-wrap"
      },
      "5ec24883bab33c11af39f705": {
        rss: "https://feeds.acast.com/public/shows/5ec24883bab33c11af39f705",
        Podcast: "Daily Dose",
        SoundCloud: "https://soundcloud.com/dailydosenl",
        Apple: "https://podcasts.apple.com/in/podcast/daily-dose/id1456761991",
        Spotify: "https://open.spotify.com/show/1IZFkY5Q35h3DkVJvgkG4i?si=gjDPqoPERbi4Nn-nPI9hkw",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/daily-dose-7",
        TuneIn: "https://tunein.com/podcasts/News--Politics-Podcasts/Daily-Dose-p1285249/",
        Hubhopper: "https://hubhopper.com/podcast/daily-dose/9681",
        Castbox: "https://castbox.fm/channel/Daily-Dose-id2056486?country=us",
        Saavn: "https://www.jiosaavn.com/shows/daily-dose/1/3k6CN3B0FXk_",
        "Google Podcasts": "https://podcasts.google.com/?q=Daily%20Dose",
        Overcast: "https://overcast.fm/itunes1456761991/daily-dose",
        "Pocket Casts": "https://pca.st/S8Mm",
        "Podcast Addict": "https://podplayer.net/?podId=2848927",
        Headfone: "https://www.headfone.co.in/channel/daily-dose/",
        Breaker: "https://www.breaker.audio/daily-dose-9"
      },
      "5ec247bf1ad9f849b1e3c640": {
        rss: "https://feeds.acast.com/public/shows/5ec247bf1ad9f849b1e3c640",
        Podcast: "NL Charcha",
        SoundCloud: "https://soundcloud.com/user-679077484",
        Apple: "https://podcasts.apple.com/in/podcast/nl-charcha/id1459652833",
        Spotify: "https://open.spotify.com/show/3U8WyKU471UtY4fxqcARQS?si=4l94hF_OQ6Ox2b2G0F5yLw",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/nl-charcha",
        TuneIn: "https://tunein.com/podcasts/News--Politics-Podcasts/NL-Charcha-p1285247/",
        Hubhopper: "https://hubhopper.com/podcast/nl-charcha/9683",
        Castbox: "https://castbox.fm/channel/NL-Charcha-id2082559?country=us",
        Saavn: "https://www.jiosaavn.com/shows/nl-charcha/1/L91z-RKTxAU_",
        "Google Podcasts": "https://podcasts.google.com/?q=NL%20Charcha",
        Overcast: "https://overcast.fm/itunes1459652833/nl-charcha",
        "Pocket Casts": "https://pca.st/9iqX",
        "Podcast Addict": "https://podplayer.net/?podId=2848930",
        Headfone: "https://www.headfone.co.in/channel/nl-charcha-1/",
        Breaker: "https://www.breaker.audio/nl-charcha"
      },
      "5ec246dc70f8f107de229629": {
        rss: "https://feeds.acast.com/public/shows/5ec246dc70f8f107de229629",
        Podcast: "Reporters Without orders",
        SoundCloud: "https://soundcloud.com/user-711229729",
        Apple: "https://podcasts.apple.com/in/podcast/reporters-without-orders/id1462395750",
        Spotify: "https://open.spotify.com/show/379g0Qt1UDMVEVbIPZtQv4?si=gPyoehZ-R1euCstDxHKqUQ",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/reporters-without-orders",
        TuneIn: "https://tunein.com/podcasts/News--Politics-Podcasts/Reporters-Without-Orders-p1285243/",
        Hubhopper: "https://hubhopper.com/podcast/reporters-without-orders/9682",
        Castbox: "https://castbox.fm/channel/Reporters-Without-Orders-id2115268?country=us",
        Saavn: "https://www.jiosaavn.com/shows/reporters-without-orders/1/xDK3Jq1GnM_",
        "Google Podcasts": "https://podcasts.google.com/?q=Reporters%20Without%20orders",
        Overcast: "https://overcast.fm/itunes1462395750/reporters-without-orders",
        "Pocket Casts": "https://pca.st/6A2z",
        "Podcast Addict": "https://podplayer.net/?podId=2848931",
        Headfone: "https://www.headfone.co.in/channel/reporters-without-orders-1/",
        Breaker: "https://www.breaker.audio/reporters-without-orders"
      },
      "5ebe751be3f889048a3fe4c0": {
        rss: "https://feeds.acast.com/public/shows/5ebe751be3f889048a3fe4c0",
        Podcast: "Newslaundry Conversations",
        SoundCloud: "https://soundcloud.com/user-748722290",
        Apple: "https://podcasts.apple.com/in/podcast/newslaundry-conversations/id1505510786",
        Spotify: "https://open.spotify.com/show/1xsk9Vi4rwr1QohADPJNmm?si=B9QKAKIXSh-C9i7Cbs_xIg",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/newslaundry",
        TuneIn: "https://tunein.com/podcasts/News--Politics-Podcasts/Newslaundry-p1310553/",
        Hubhopper: "https://hubhopper.com/podcast/newslaundry-conversations/310004",
        Castbox: "https://castbox.fm/channel/Newslaundry-Conversations-id2729962?country=us",
        Saavn: "https://www.jiosaavn.com/shows/newslaundry-conversations/1/ML8Ov68lMz0_",
        "Google Podcasts": "https://podcasts.google.com/?q=Newslaundry%20Conversations",
        Overcast: "https://overcast.fm/itunes1505510786/newslaundry-conversations",
        "Pocket Casts": "https://pca.st/gnr85amg",
        "Podcast Addict": "https://podplayer.net/?podId=2822776",
        Headfone: "https://www.headfone.co.in/channel/newslaundry-coversations/",
        Breaker: "https://www.breaker.audio/newslaundry-conversations"
      },
      "5ec245800030647b6724c55e": {
        rss: "https://feeds.acast.com/public/shows/5ec245800030647b6724c55e",
        Podcast: "Highway on My Podcast",
        SoundCloud: "https://soundcloud.com/user-476778740",
        Apple: "https://podcasts.apple.com/in/podcast/highway-on-my-podcast/id1505546047",
        Spotify: "https://open.spotify.com/show/4dWBebBv0a0MxHywdlTLuG?si=Nb1rRtj9Q_Cp8NbLUu9eDg",
        Stitcher: "https://www.stitcher.com/podcast/newslaundry-podcast/highway-on-my-podcast",
        TuneIn: "https://tunein.com/podcasts/Media--Entertainment-Podcasts/Highway-On-My-Podcast-p1310554/",
        Hubhopper: "https://hubhopper.com/podcast/highway-on-my-podcast/310005",
        Castbox: "https://castbox.fm/channel/Highway-On-My-Podcast-id2729963?country=us",
        Saavn: "https://www.jiosaavn.com/shows/highway-on-my-podcast/1/-4yEERwyuDM_",
        "Google Podcasts": "https://podcasts.google.com/?q=Highway%20on%20My%20Podcast",
        Overcast: "https://overcast.fm/itunes1505546047/highway-on-my-podcast",
        "Pocket Casts": "https://pca.st/zppajgzm",
        "Podcast Addict": "https://podplayer.net/?podId=2819619",
        Headfone: "https://www.headfone.co.in/channel/highway-on-my-podcast/",
        Breaker: "https://www.breaker.audio/highway-on-my-podcast"
      }
    }
  };
  return IntegrationData;
};

module.exports = Integrations;
